var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsPerksInsider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.245 5H28v2.997h2.993v39.006H28V50h5.245a.754.754 0 0 0 .755-.756V5.743A.76.76 0 0 0 33.245 5ZM26.098.011.638 4.272A.761.761 0 0 0 0 5.018v43.963c0 .367.278.679.639.747l25.459 4.26a.763.763 0 0 0 .902-.746V.758c0-.462-.444-.828-.902-.747ZM18.67 16.457l-2.86 2.564.778 3.718c.027.136-.125.244-.25.177l-3.387-1.873-3.387 1.873c-.125.067-.278-.041-.25-.177l.777-3.718-2.86-2.564a.162.162 0 0 1 .098-.285l3.859-.434 1.61-3.46a.165.165 0 0 1 .305 0l1.61 3.46 3.86.434c.152.013.208.19.097.285Zm4.4 16.432c-.971 0-1.763-.774-1.763-1.724s.792-1.723 1.763-1.723c.972 0 1.763.774 1.763 1.723 0 .95-.79 1.724-1.763 1.724Z",
    fill: "#49B9DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsPerksInsider);
export default __webpack_public_path__ + "static/media/US-perks-Insider.477d1e46ae1c0e86fd5a40195240ca33.svg";
export { ForwardRef as ReactComponent };